const PAYLOAD = {
    type: 'error',
    title: 'Client error. Please check error details in Sentry',
};
export const notifyExchangeServerOfClientError = async (request, { orderId, isChainedOrder, logger, }) => {
    const endpoint = isChainedOrder ? 'chained-orders' : 'orders';
    try {
        await request(`${endpoint}/${encodeURIComponent(orderId)}/logs`).post(PAYLOAD);
        return;
    }
    catch (err) {
        if (!isChainedOrder) {
            logger?.warn('notify exchange client error failed', err);
            return;
        }
    }
    try {
        await request(`orders/${encodeURIComponent(orderId)}/logs`).post(PAYLOAD);
    }
    catch (err) {
        logger?.warn('notify exchange client error failed', err);
    }
};
